import React, { Children } from 'react'

export default function Panels({children}) {
  return (
    <div className='header-panels'>{children}</div>
  )
}
